
import { isMobileResponsive } from '@/utils/mixins';
import { mapActions } from 'vuex';
import CloseIcon from '~/components/ui/icons/CloseIcon.vue';
import { GifTypes } from '~/types/models/gifTypes';
import klipyWatermarkLogo from '~/assets/img/klipy-logo-light.png';
import giphyWatermarkLogo from '~/assets/img/powered-by-giphy-image.png';
import klipyPoweredLogo from '~/assets/img/powered-by-klipy-image.png';

export default {
  name: 'MultipleImageDisplay',
  components: {
    CloseIcon,
  },
  mixins: [isMobileResponsive],
  props: {
    showCloseBtn: {
      type: Boolean,
      default: false,
    },
    allowCarousel: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: () => [],
    },
    isReply: {
      type: Boolean,
      default: false,
    },
    gifType: {
      type: String,
      default: '',
    },
    showKlipyPreviewLogo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showImgViewer: false,
      displayedImgUri: '',
    };
  },
  computed: {
    hasMultipleImages() {
      return (this.images?.length ?? 0) > 1;
    },
    firstImage() {
      return this.images[0];
    },
    resolvedGifType() {
      if (this.gifType) {
        return this.gifType;
      }

      if (this.firstImage?.src?.includes('klipy.com')) {
        return GifTypes.KLIPY;
      }

      if (this.firstImage?.src?.includes('giphy.com')) {
        return GifTypes.GIPHY;
      }

      return null;
    },

    watermarkImage() {
      switch (this.gifType) {
        case GifTypes.KLIPY:
          return klipyWatermarkLogo.default || klipyWatermarkLogo;
        case GifTypes.GIPHY:
          return giphyWatermarkLogo.default || giphyWatermarkLogo;
        default:
          return null;
      }
    },
    showPoweredByLogo() {
      return (
        this.resolvedGifType === GifTypes.KLIPY && this.showKlipyPreviewLogo
      );
    },

    poweredByLogoImage() {
      if (this.resolvedGifType === GifTypes.KLIPY) {
        return klipyPoweredLogo.default || klipyPoweredLogo;
      }
      return null;
    },

    maxImageHeight() {
      return this.isMobileResponsive ? 350 : 400;
    },
    gifHeight() {
      return this.isMobileResponsive
        ? this.isReply
          ? '150px'
          : '220px'
        : this.isReply
        ? '150px'
        : '300px';
    },
    gifWidth() {
      return this.isMobileResponsive
        ? '100%'
        : this.isReply
        ? '300px'
        : '650px';
    },
  },
  methods: {
    ...mapActions('modals', ['showImageSliderModal']),
    handleCarouselModal(index) {
      this.showImageSliderModal({ navigateTo: index, images: this.images });
    },
    handleShowImgViewer(uri) {
      this.displayedImgUri = uri;
      this.showImgViewer = true;
    },
    handleCloseImgViewer() {
      this.showImgViewer = false;
      this.displayedImgUri = '';
    },
  },
};
